import React, { useState, useEffect } from "react";
import { Link, Route } from "react-router-dom";
import "./cover.jsx";
import Login from "./Login";
import Logout from "./Logout";
import "./navigation.css";
import "bootstrap/dist/css/bootstrap.css";
import { FirebaseAuth, useForAuthorisation } from "./context";
import { useOnlineStatus } from "../contexts/OnlineStatusContext";

// it takes in multiple props which are destructured - it comes from the various components - to set the navbar name colors

// all these props can be removed. in the other components use effect is already setting the nav name to the color when the
// component renders/paints...these clicks may not render?

//let initialrender = true;
function Navigation({
  savedIcon,
  //  savedIcon1,
  stylingOnClickTB,
  stylingOnClickLedger,
  // stylingOnClickNotes,
  stylingOnClickSoCE,
  stylingOnClickTBCurrent,
  stylingOnClickCashflow,
  stylingOnClickJournals,
  stylingOnClickInfo,
  stylingOnClickInvoices,
  stylingOnClickSoCI,
  stylingOnClickSoFP,
  stylingOnClickTax,
  stylingOnClickPdfDisplay,
  stylingOnClickSupport,
  colorNotesMenu,
  stylingOnClickTasks,
}) {
  // const [newData, setNewData] = useState([]);
  // const [activeState, setActiveState] = useState();
  // const [stylingOnClickTB, setStylingOnClickTB] = useState();
  const [, setStylingOnClickInfo] = useState();
  const [, setStylingOnClickTBCurrent] = useState();
  const [, setStylingOnClickTB] = useState();
  const [, setStylingOnClickInvoices] = useState();
  const [, setStylingOnClickSoCI] = useState();
  const [, setStylingOnClickSoFP] = useState();
  const [, setStylingOnClickSoCE] = useState();
  const [, setStylingOnClickLedger] = useState();
  const [, setStylingOnClickCashflow] = useState();
  const [, setStylingOnClickJournals] = useState();
  const [, setStylingOnClickTax] = useState();
  const [, setStylingOnClickPdfDisplay] = useState();
  const [, setStylingOnClickSupport] = useState();
  const [, setStylingOnClickTasks] = useState();
  const [stylingOnClickBudget, setStylingOnClickBudget] = useState();
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const [showDataEntryDropdown, setShowDataEntryDropdown] = useState(false);
  const [showFinancialsDropdown, setShowFinancialsDropdown] = useState(false);
  const [showInvoicesDropdown, setShowInvoicesDropdown] = useState(false);
  const [showTaxBudgetDropdown, setShowTaxBudgetDropdown] = useState(false);
  const [showCommandCentreDropdown, setShowCommandCentreDropdown] =
    useState(false);
  // const [loading, setLoading] = useState(false);

  // Track mobile view state
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Dark mode detection for inline colour adjustments
  const [isDarkMode, setIsDarkMode] = useState(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => setIsDarkMode(e.matches);
    if (media.addEventListener) media.addEventListener("change", handler);
    else media.addListener(handler);
    return () => {
      if (media.removeEventListener)
        media.removeEventListener("change", handler);
      else media.removeListener(handler);
    };
  }, []);

  // Determine if hover should be disabled
  // Disable hover if:
  // 1. We are in mobile view (width < 992px) - menu is stacked/different layout
  // 2. Device does not support hover (touch devices)
  // Note: Chrome on trackpads may not report (pointer: fine) correctly
  // So we use hover detection alone OR check for mouse events
  const isHoverCapable = (() => {
    if (!window.matchMedia) return !("ontouchstart" in window);
    
    // Check if hover is available
    const hasHover = window.matchMedia("(hover: hover)").matches;
    
    // Check if any pointer is available (trackpads should match this)
    const hasAnyPointer = window.matchMedia("(any-pointer: fine)").matches;
    
    // If hover is supported OR we have a fine pointer (trackpad/mouse), enable hover
    return hasHover || hasAnyPointer || !("ontouchstart" in window);
  })();
  const disableHover = isMobileView || !isHoverCapable;
  // Use disableHover for isTouchDevice to maintain existing logic in JSX
  const isTouchDevice = disableHover;

  const { emailDetails } = useForAuthorisation();
  const { isOnline, connectionQuality } = useOnlineStatus();
  const qualityLabel = connectionQuality
    ? connectionQuality.charAt(0).toUpperCase() + connectionQuality.slice(1)
    : null;
  const statusTitle = isOnline
    ? qualityLabel
      ? `Online — Connection: ${qualityLabel}`
      : "Online — Connection quality data unavailable"
    : "Offline — No internet connection";
  const statusChipClassName = `status-chip ${isOnline ? "online" : "offline"}`;
  const dotColor = isOnline
    ? connectionQuality === "good"
      ? "#10b981"
      : connectionQuality === "fair"
      ? "#f59e0b"
      : connectionQuality === "poor"
      ? "#ef4444"
      : "#10b981"
    : "#ef4444";
  const dotShadow = isOnline
    ? connectionQuality === "good"
      ? "0 0 6px rgba(16, 185, 129, 0.6)"
      : connectionQuality === "fair"
      ? "0 0 6px rgba(245, 158, 11, 0.45)"
      : connectionQuality === "poor"
      ? "0 0 6px rgba(239, 68, 68, 0.5)"
      : "0 0 6px rgba(16, 185, 129, 0.6)"
    : "0 0 6px rgba(239, 68, 68, 0.6)";
  //check if there exists a company , if not nav links should not be enabled.
  // let MainUserUID = auth.currentUser.uid;
  //const [linksdisabledboolean, setlinksdisabledboolean] = useState([]);
  // useEffect(() => {
  //   if (initialrender) {
  //     initialrender = false;
  //     return;
  //   }
  //   const urlDb = "/UserSelections/" + MainUserUID;
  //   const newUrlDb = database.ref(urlDb);

  //   newUrlDb.on("value", (snapshot) => {    setLoading(true);
  //     const accounts = snapshot.val();

  //     let newAccounts = [];

  //     newAccounts.push({ ...accounts });

  //     setNewData(newAccounts);

  //    setLoading(false); });

  //   return () => newUrlDb.off();
  // }, [MainUserUID]);
  //console.log(newData);
  // const [linksdisabled, setLinksDisabled] = useState(false);
  //is user hasnt added a company all links should redirect to My Entities page, or alternatively we can set up a demo company but
  //its not setup yet. if users go to links it should work, however errors may result due to less optimizations for no company
  //added
  //
  // const linksdisabledboolean =
  //   newData.map((el1) => Object.keys(el1).length).toString() == 0
  //     ? true
  //     : false;
  //use useEffect?

  // useEffect(() => {
  //   if (initialrender) {
  //     initialrender = false;
  //     return;
  //   }
  //   setLoading(true);

  //   setlinksdisabledboolean(
  //     newData.map((el1) => Object.keys(el1).length).toString() == 0
  //       ? true
  //       : false
  //   );
  //   setLoading(false);
  // }, [newData]);

  // console.log(linksdisabledboolean);
  // if (loading) {
  //   return (
  //     <div
  //       // style={{ marginRight: 115, marginTop: 10 }}
  //       className="spinner-border text-primary"
  //       role="status"
  //     ></div>
  //   );
  // }

  return (
    <FirebaseAuth>
      <style>
        {`
          .navbar-nav::-webkit-scrollbar {
            display: none;
          }
          
          /* Chrome trackpad/mouse hover fixes - use any-pointer to catch trackpads */
          @media (hover: hover), (any-pointer: fine) {
            .nav-item {
              pointer-events: auto !important;
            }
            
            .nav-item > div[style*="position: absolute"] {
              pointer-events: auto !important;
            }
          }
          
          /* Force GPU acceleration and ensure hover works */
          .nav-item {
            transform: translateZ(0);
            -webkit-transform: translateZ(0);
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
          }
          
          /* Explicitly enable pointer events on dropdown containers */
          .nav-item > div {
            pointer-events: auto;
          }
          
          .compact-nav-item {
            white-space: nowrap;
            font-size: 14px;
            padding: 6px 8px !important;
            pointer-events: auto;
          }
          @media (max-width: 1200px) {
            .compact-nav-item {
              font-size: 13px;
              padding: 5px 6px !important;
            }
          }
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
          .nav-right-panel {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 6px;
          }
          .nav-actions-row {
            display: flex;
            align-items: center;
            gap: 8px;
            background: rgba(255, 255, 255, 0.4);
            padding: 6px 10px;
            border-radius: 8px;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
            backdrop-filter: blur(4px);
          }
          .nav-actions-row a,
          .nav-actions-row label {
            display: inline-flex;
            align-items: center;
          }
          @media (max-width: 991px) {
            .navbar-collapse {
              background: linear-gradient(135deg, #bdf3ff, #eefff7);
              padding: 1rem;
              border-radius: 8px;
              margin-top: 0.5rem;
            }
            .navbar-nav {
              flex-direction: column !important;
              width: 100%;
              align-items: stretch;
            }
            .nav-item {
              width: 100%;
              margin: 0.25rem 0 !important;
            }
            /* Reset padding on the Link wrapper so inner li can handle it */
            a.nav-link {
              padding: 0 !important;
              width: 100%;
            }
            /* Target all compact-nav-items (both li inside Link and div dropdown triggers) */
            .compact-nav-item {
              width: 100% !important;
              display: flex !important;
              justify-content: flex-start !important;
              align-items: center !important;
              padding: 0.875rem 1rem !important;
              text-align: left !important;
              border-radius: 8px !important;
              margin-bottom: 0.25rem !important;
            }
            /* Mobile dropdown positioning */
            .nav-item > div[style*="position: absolute"] {
              position: relative !important;
              left: auto !important;
              top: auto !important;
              width: 100% !important;
              padding-top: 0 !important;
              margin-top: 0.5rem !important;
            }
          }
          @media (prefers-color-scheme: dark) {
            .navbar {
              background-image: linear-gradient(45deg, #1e293b, #0f172a) !important;
              border-bottom: 1px solid rgba(255,255,255,0.1) !important;
            }
            .navbar-collapse {
              background: linear-gradient(135deg, #1e293b, #0f172a) !important;
            }
            .nav-link.compact-nav-item {
              color: #e2e8f0 !important;
            }
            .navbar-brand h1 {
              color: #e2e8f0 !important;
            }
            .status-chip.online {
              background: rgba(6, 78, 59, 0.5) !important;
              color: #6ee7b7 !important;
            }
            .status-chip.offline {
              background: rgba(127, 29, 29, 0.5) !important;
              color: #fca5a5 !important;
            }
          }
          .status-chip {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px 10px;
            border-radius: 8px;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.01em;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .status-chip:hover {
            transform: translateY(-1px);
            box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12);
          }
          .status-chip.online {
            background: rgba(236, 253, 245, 0.5);
            color: #047857;
            box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.2);
          }
          .status-chip.offline {
            background: rgba(254, 242, 242, 0.5);
            color: #b91c1c;
            box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.2);
          }
          .status-dot {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
          .status-chip.offline .status-dot {
            animation: pulse 2s infinite;
          }
          .status-quality {
            font-size: 11px;
            font-weight: 500;
            text-transform: capitalize;
            opacity: 0.9;
          }
          .status-quality::before {
            content: "•";
            margin: 0 4px 0 2px;
            opacity: 0.6;
          }
          /* Fancy Plus Icon Animation */
          .fancy-plus {
            display: inline-block;
            width: 20px;
            height: 20px;
            position: relative;
            transition: transform 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          }
          .fancy-plus::before,
          .fancy-plus::after {
            content: '';
            position: absolute;
            background: currentColor;
            transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          }
          .fancy-plus::before {
            width: 2px;
            height: 12px;
            left: 9px;
            top: 4px;
          }
          .fancy-plus::after {
            width: 12px;
            height: 2px;
            left: 4px;
            top: 9px;
          }
          .fancy-plus.open {
            transform: rotate(135deg);
          }
          .dropdown-menu-custom {
            position: absolute;
            top: 100%;
            left: 0;
            min-width: 240px;
            padding: 0.5rem;
            background-color: #ffffff;
            border-radius: 12px;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            border: 1px solid #f1f5f9;
            z-index: 1000;
            animation: slideDown 0.2s ease-out forwards;
          }
          /* Navbar toggler dark mode */
          .navbar-toggler.dark {
            background-color: #1e293b !important;
            color: #e2e8f0 !important;
            border-radius: 8px !important;
            padding: 0.75rem !important;
          }
          .navbar-toggler.dark .navbar-toggler-icon {
            background-color: #e2e8f0 !important;
          }
          @keyframes slideDown {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .dropdown-item-custom {
            display: flex;
            align-items: center;
            padding: 0.75rem 1rem;
            color: #475569;
            text-decoration: none;
            border-radius: 8px;
            transition: all 0.2s ease;
            font-weight: 500;
            font-size: 0.9rem;
          }
          .dropdown-item-custom:hover {
            background-color: #f8fafc;
            color: #2563eb;
            transform: translateX(4px);
          }
        `}
      </style>
      <div style={{ width: "100%" }}>
        <nav
          style={{
            width: "100%",
            backgroundImage: "linear-gradient(45deg, #bdf3ff, #eefff7)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            borderBottom: "1px solid rgba(255,255,255,0.2)",
            paddingTop: "1rem",
            paddingBottom: "1rem",
          }}
          className="navbar navbar-expand-lg navbar-light bg-light"
        >
          {savedIcon === "Saving..." ? (
            <>
              <h1 style={{ fontSize: 30 }}>
                FilingSta
                <h1
                  style={{ fontSize: 15 }}
                  className="spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="sr-only"></span>
                </h1>
                k
              </h1>{" "}
              <button
                className={`navbar-toggler ${isDarkMode ? "dark" : ""}`}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </>
          ) : (
            <>
              {" "}
              <Link to="/">
                {" "}
                <h1
                  style={{
                    fontSize: 30,
                    color: isDarkMode ? "#e2e8f0" : "black",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    margin: 0,
                  }}
                >
                  FilingStack
                </h1>{" "}
              </Link>{" "}
              <button
                className={`navbar-toggler ${isDarkMode ? "dark" : ""}`}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </>
          )}
          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
            style={{
              overflowX: "visible",
              overflowY: "visible",
            }}
          >
            <ul
              style={{
                textAlign: "left",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                marginBottom: "0",
                paddingLeft: "0",
                listStyle: "none",
                gap: "4px",
              }}
              className="navbar-nav mr-auto"
            >
              {/* My Entities Dropdown */}
              <li
                className="nav-item"
                style={{
                  position: "relative",
                  zIndex: showCommandCentreDropdown ? 10000 : "auto",
                }}
                onMouseEnter={
                  !isTouchDevice
                    ? () => setShowCommandCentreDropdown(true)
                    : undefined
                }
                onMouseLeave={
                  !isTouchDevice
                    ? () => setShowCommandCentreDropdown(false)
                    : undefined
                }
              >
                <div
                  className="nav-link compact-nav-item"
                  style={{
                    color: showCommandCentreDropdown
                      ? "#ffffff"
                      : stylingOnClickInfo || stylingOnClickSupport
                      ? "MediumBlue"
                      : "#4b5563",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight:
                      stylingOnClickInfo || stylingOnClickSupport
                        ? "600"
                        : "normal",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    padding: "6px 8px",
                    background: showCommandCentreDropdown
                      ? "linear-gradient(135deg, #0ea5e9 0%, #0284c7 50%, #0369a1 100%)"
                      : "transparent",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowCommandCentreDropdown(!showCommandCentreDropdown);
                  }}
                >
                  🏛️ My Entities
                  <span
                    className={`fancy-plus ${
                      showCommandCentreDropdown ? "open" : ""
                    }`}
                    style={{
                      color: showCommandCentreDropdown ? "#fff" : "inherit",
                    }}
                  />
                </div>
                {showCommandCentreDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      minWidth: "320px",
                      paddingTop: "0.5rem",
                      pointerEvents: "auto",
                      zIndex: 10000,
                      opacity: showCommandCentreDropdown ? 1 : 0,
                      visibility: showCommandCentreDropdown
                        ? "visible"
                        : "hidden",
                      transform: showCommandCentreDropdown
                        ? "translateY(0) scale(1)"
                        : "translateY(-10px) scale(0.95)",
                      transition:
                        "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                    }}
                  >
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #e0f2fe 100%)",
                        borderRadius: "12px",
                        boxShadow: showCommandCentreDropdown
                          ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                          : "none",
                        border: "1px solid #0ea5e9",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                          padding: "1rem 1.25rem",
                          borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontWeight: "700",
                            fontSize: "0.95rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <span style={{ fontSize: "1.2rem" }}>🏛️</span>
                          My Entities
                        </div>
                        <div
                          style={{
                            color: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.75rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          Manage Companies, Trusts & Sole Props
                        </div>
                      </div>

                      <div style={{ padding: "0.5rem" }}>
                        <Link
                          to="/AfterLoginPage"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(14, 165, 233, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickInfo("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(14, 165, 233, 0.3)",
                            }}
                          >
                            🏢
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#075985",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Company & Clients
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Add and Select a business
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#0ea5e9",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/ClientCollaboration"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(14, 165, 233, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(14, 165, 233, 0.3)",
                            }}
                          >
                            🤝
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#075985",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Client Portal
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Open collaboration, docs and approvals
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#0ea5e9",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/ShortCut"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #cffafe 0%, #a5f3fc 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(14, 116, 144, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickInfo("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(8, 145, 178, 0.3)",
                            }}
                          >
                            📊
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#0e7490",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Dashboard
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Open shortcuts and key actions
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#0891b2",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/Support"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #bae6fd 0%, #7dd3fc 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(2, 132, 199, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickSupport("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(14, 165, 233, 0.3)",
                            }}
                          >
                            🆘
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#075985",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Support
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Get help & assistance
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#0ea5e9",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="./UsageInfo"
                          target="_blank"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #7dd3fc 0%, #38bdf8 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(3, 105, 161, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(14, 165, 233, 0.3)",
                            }}
                          >
                            📚
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#075985",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Documentation
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Guides & tutorials
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#0ea5e9",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* Settings Dropdown */}
              <li
                className="nav-item"
                style={{
                  position: "relative",
                  zIndex: showSettingsDropdown ? 10000 : "auto",
                }}
                onMouseEnter={
                  !isTouchDevice
                    ? () => setShowSettingsDropdown(true)
                    : undefined
                }
                onMouseLeave={
                  !isTouchDevice
                    ? () => setShowSettingsDropdown(false)
                    : undefined
                }
              >
                <div
                  className="nav-link compact-nav-item"
                  style={{
                    color: showSettingsDropdown ? "#ffffff" : "#4b5563",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: "normal",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    padding: "6px 8px",
                    background: showSettingsDropdown
                      ? "linear-gradient(135deg, #a855f7 0%, #8b5cf6 50%, #7c3aed 100%)"
                      : "transparent",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSettingsDropdown(!showSettingsDropdown);
                  }}
                >
                  ⚙️ Settings
                  <span
                    className={`fancy-plus ${
                      showSettingsDropdown ? "open" : ""
                    }`}
                    style={{ color: showSettingsDropdown ? "#fff" : "inherit" }}
                  />
                </div>
                {showSettingsDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      minWidth: "320px",
                      paddingTop: "0.5rem",
                      pointerEvents: "auto",
                      zIndex: 10000,
                      opacity: showSettingsDropdown ? 1 : 0,
                      visibility: showSettingsDropdown ? "visible" : "hidden",
                      transform: showSettingsDropdown
                        ? "translateY(0) scale(1)"
                        : "translateY(-10px) scale(0.95)",
                      transition:
                        "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                    }}
                  >
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f3e8ff 100%)",
                        borderRadius: "12px",
                        boxShadow: showSettingsDropdown
                          ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                          : "none",
                        border: "1px solid #a855f7",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                          padding: "1rem 1.25rem",
                          borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontWeight: "700",
                            fontSize: "0.95rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <span style={{ fontSize: "1.2rem" }}>⚙️</span>
                          Settings
                        </div>
                        <div
                          style={{
                            color: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.75rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          Configure and manage system
                        </div>
                      </div>

                      <div style={{ padding: "0.5rem" }}>
                        <Link
                          to="/Payment"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(168, 85, 247, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(168, 85, 247, 0.3)",
                            }}
                          >
                            💳
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#6b21a8",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Payments
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Payment integrations
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#a855f7",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/EngagementLetters"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(168, 85, 247, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(168, 85, 247, 0.3)",
                            }}
                          >
                            📄
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#6b21a8",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Engagement Letters
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Generate & send for e-signature
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#a855f7",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/settings"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(168, 85, 247, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickInfo("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(168, 85, 247, 0.3)",
                            }}
                          >
                            ⚙️
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#6b21a8",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Settings
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Company & system settings
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#a855f7",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/CompliancePortal"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #ecfccb 0%, #d9f99d 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(101, 163, 13, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #84cc16 0%, #65a30d 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(101, 163, 13, 0.3)",
                            }}
                          >
                            🧩
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#365314",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Compliance Portal
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#4d7c0f",
                                lineHeight: "1.2",
                              }}
                            >
                              Corporate actions, workflows and filings
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#4d7c0f",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/CIPCTracking"
                          style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.875rem 1rem", borderRadius: "8px", textDecoration: "none", marginTop: "0.25rem", background: "#edf7f3", color: "#087f75" }}
                        >
                          <div style={{ fontSize: "1.25rem" }}>✉️</div>
                          <div><div style={{ fontWeight: 600, fontSize: "0.9rem" }}>CIPC Automation</div><div style={{ fontSize: "0.75rem", marginTop: 3 }}>Annual filings, client emails & follow-ups</div></div>
                        </Link>

                        <Link
                          to="./UserProfile"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #e9d5ff 0%, #d8b4fe 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(147, 51, 234, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(168, 85, 247, 0.3)",
                            }}
                          >
                            👤
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#6b21a8",
                                marginBottom: "0.15rem",
                              }}
                            >
                              User Profile
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Manage your account
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#a855f7",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/SignUpAndAddUser"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(124, 58, 237, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(168, 85, 247, 0.3)",
                            }}
                          >
                            👥
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#6b21a8",
                                marginBottom: "0.15rem",
                              }}
                            >
                              User Management
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Add users
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#a855f7",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/AuditLogs"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(168, 85, 247, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(168, 85, 247, 0.3)",
                            }}
                          >
                            📋
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#6b21a8",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Audit Logs
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              View system activity
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#a855f7",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </li>{" "}
              {/* Invoices Dropdown */}
              <li
                className="nav-item"
                style={{
                  position: "relative",
                  zIndex: showInvoicesDropdown ? 10000 : "auto",
                }}
                onMouseEnter={
                  !isTouchDevice
                    ? () => setShowInvoicesDropdown(true)
                    : undefined
                }
                onMouseLeave={
                  !isTouchDevice
                    ? () => setShowInvoicesDropdown(false)
                    : undefined
                }
              >
                <div
                  className="nav-link compact-nav-item"
                  style={{
                    color: showInvoicesDropdown
                      ? "#ffffff"
                      : stylingOnClickInvoices
                      ? "MediumBlue"
                      : "#4b5563",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: stylingOnClickInvoices ? "600" : "normal",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    padding: "6px 8px",
                    background: showInvoicesDropdown
                      ? "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 50%, #6d28d9 100%)"
                      : "transparent",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowInvoicesDropdown(!showInvoicesDropdown);
                  }}
                >
                  🧾 Invoices
                  <span
                    className={`fancy-plus ${
                      showInvoicesDropdown ? "open" : ""
                    }`}
                    style={{
                      color: showInvoicesDropdown ? "#fff" : "inherit",
                    }}
                  />
                </div>
                {showInvoicesDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      minWidth: "320px",
                      paddingTop: "0.5rem",
                      zIndex: 10000,
                      opacity: showInvoicesDropdown ? 1 : 0,
                      visibility: showInvoicesDropdown ? "visible" : "hidden",
                      transform: showInvoicesDropdown
                        ? "translateY(0) scale(1)"
                        : "translateY(-10px) scale(0.95)",
                      transition:
                        "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                      pointerEvents: showInvoicesDropdown ? "auto" : "none",
                    }}
                  >
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #ede9fe 100%)",
                        borderRadius: "12px",
                        boxShadow: showInvoicesDropdown
                          ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                          : "none",
                        border: "1px solid #8b5cf6",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                          padding: "1rem 1.25rem",
                          borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontWeight: "700",
                            fontSize: "0.95rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <span style={{ fontSize: "1.2rem" }}>🧾</span>
                          Invoices
                        </div>
                        <div
                          style={{
                            color: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.75rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          Manage sales and inventory
                        </div>
                      </div>

                      <div style={{ padding: "0.5rem" }}>
                        <Link
                          to="/InvoicesPage"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(139, 92, 246, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickInvoices("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(139, 92, 246, 0.3)",
                            }}
                          >
                            📊
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#5b21b6",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Dashboard
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Invoice overview
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#8b5cf6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/Invoices"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(124, 58, 237, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickInvoices("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(139, 92, 246, 0.3)",
                            }}
                          >
                            ➕
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#5b21b6",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Add Invoice
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Create new invoice
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#8b5cf6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/InvoicesAdded"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #c4b5fd 0%, #a78bfa 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(109, 40, 217, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickInvoices("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(139, 92, 246, 0.3)",
                            }}
                          >
                            📋
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#5b21b6",
                                marginBottom: "0.15rem",
                              }}
                            >
                              View Invoices
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              History & status
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#8b5cf6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/customer-aging-report"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(139, 92, 246, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickInvoices("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(139, 92, 246, 0.3)",
                            }}
                          >
                            📄
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#5b21b6",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Customer Statement
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Aging reports
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#8b5cf6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/supplier-aging-report"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(139, 92, 246, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickInvoices("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(139, 92, 246, 0.3)",
                            }}
                          >
                            📄
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#5b21b6",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Supplier Aging
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Outstanding supplier balances
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#8b5cf6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/inventory-management"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(124, 58, 237, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickInvoices("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(139, 92, 246, 0.3)",
                            }}
                          >
                            📦
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#5b21b6",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Inventory
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Stock management
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#8b5cf6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              <span
                style={{
                  margin: "0 8px",
                  color: "#6b7280",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                |
              </span>
              {/* Data Entry Dropdown */}
              <li
                className="nav-item"
                style={{
                  position: "relative",
                  zIndex: showDataEntryDropdown ? 10000 : "auto",
                }}
                onMouseEnter={
                  !isTouchDevice
                    ? () => setShowDataEntryDropdown(true)
                    : undefined
                }
                onMouseLeave={
                  !isTouchDevice
                    ? () => setShowDataEntryDropdown(false)
                    : undefined
                }
              >
                <div
                  className="nav-link compact-nav-item"
                  style={{
                    color: showDataEntryDropdown
                      ? "#ffffff"
                      : stylingOnClickTBCurrent ||
                        stylingOnClickJournals ||
                        colorNotesMenu
                      ? "MediumBlue"
                      : "#4b5563",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight:
                      stylingOnClickTBCurrent ||
                      stylingOnClickJournals ||
                      colorNotesMenu
                        ? "600"
                        : "normal",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    padding: "6px 8px",
                    background: showDataEntryDropdown
                      ? "linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)"
                      : "transparent",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowDataEntryDropdown(!showDataEntryDropdown);
                  }}
                >
                  📝 Data Entry
                  <span
                    className={`fancy-plus ${
                      showDataEntryDropdown ? "open" : ""
                    }`}
                    style={{
                      color: showDataEntryDropdown ? "#fff" : "inherit",
                    }}
                  />
                </div>
                {showDataEntryDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      minWidth: "320px",
                      paddingTop: "0.5rem",
                      zIndex: 10000,
                      opacity: showDataEntryDropdown ? 1 : 0,
                      visibility: showDataEntryDropdown ? "visible" : "hidden",
                      transform: showDataEntryDropdown
                        ? "translateY(0) scale(1)"
                        : "translateY(-10px) scale(0.95)",
                      transition:
                        "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                      pointerEvents: showDataEntryDropdown ? "auto" : "none",
                    }}
                  >
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #d1fae5 100%)",
                        borderRadius: "12px",
                        boxShadow: showDataEntryDropdown
                          ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                          : "none",
                        border: "1px solid #10b981",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                          padding: "1rem 1.25rem",
                          borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontWeight: "700",
                            fontSize: "0.95rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <span style={{ fontSize: "1.2rem" }}>📝</span>
                          Data Entry
                        </div>
                        <div
                          style={{
                            color: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.75rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          Input and manage data
                        </div>
                      </div>

                      <div style={{ padding: "0.5rem" }}>
                        <Link
                          to="/Accounts"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(16, 185, 129, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickTBCurrent("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            💳
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Accounts
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Transaction allocation
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/journals"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(5, 150, 105, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickJournals("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            📝
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Journals
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Manual journal entries
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/OpeningBalances"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #6ee7b7 0%, #34d399 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(4, 120, 87, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            🧾
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Opening Balances
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Set initial balances
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/ExtractData"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #6ee7b7 0%, #34d399 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(4, 120, 87, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            📄
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Convert PDFs
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Extract data from PDFs
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/bankUpdate"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(16, 185, 129, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            🏦
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Bank Update
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Update bank balances
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/NotesMenu"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(5, 150, 105, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            📋
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Notes
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Financial notes & docs
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/AccountingSoftwareImport"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #6ee7b7 0%, #34d399 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(4, 120, 87, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            📥
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Import Software
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Import from other systems
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* Financials Dropdown */}
              <li
                className="nav-item"
                style={{
                  position: "relative",
                  zIndex: showFinancialsDropdown ? 10000 : "auto",
                }}
                onMouseEnter={
                  !isTouchDevice
                    ? () => setShowFinancialsDropdown(true)
                    : undefined
                }
                onMouseLeave={
                  !isTouchDevice
                    ? () => setShowFinancialsDropdown(false)
                    : undefined
                }
              >
                <div
                  className="nav-link compact-nav-item"
                  style={{
                    color: showFinancialsDropdown
                      ? "#ffffff"
                      : stylingOnClickTB ||
                        stylingOnClickLedger ||
                        stylingOnClickSoCI ||
                        stylingOnClickSoFP ||
                        stylingOnClickSoCE ||
                        stylingOnClickCashflow ||
                        stylingOnClickPdfDisplay
                      ? "MediumBlue"
                      : "#4b5563",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight:
                      stylingOnClickTB ||
                      stylingOnClickLedger ||
                      stylingOnClickSoCI ||
                      stylingOnClickSoFP ||
                      stylingOnClickSoCE ||
                      stylingOnClickCashflow ||
                      stylingOnClickPdfDisplay
                        ? "600"
                        : "normal",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    padding: "6px 8px",
                    background: showFinancialsDropdown
                      ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%)"
                      : "transparent",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowFinancialsDropdown(!showFinancialsDropdown);
                  }}
                >
                  📊 Financials
                  <span
                    className={`fancy-plus ${
                      showFinancialsDropdown ? "open" : ""
                    }`}
                    style={{
                      color: showFinancialsDropdown ? "#fff" : "inherit",
                    }}
                  />
                </div>
                {showFinancialsDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      minWidth: "320px",
                      paddingTop: "0.5rem",
                      zIndex: 10000,
                      opacity: showFinancialsDropdown ? 1 : 0,
                      visibility: showFinancialsDropdown ? "visible" : "hidden",
                      transform: showFinancialsDropdown
                        ? "translateY(0) scale(1)"
                        : "translateY(-10px) scale(0.95)",
                      transition:
                        "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                      pointerEvents: showFinancialsDropdown ? "auto" : "none",
                    }}
                  >
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #dbeafe 100%)",
                        borderRadius: "12px",
                        boxShadow: showFinancialsDropdown
                          ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                          : "none",
                        border: "1px solid #3b82f6",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                          padding: "1rem 1.25rem",
                          borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontWeight: "700",
                            fontSize: "0.95rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <span style={{ fontSize: "1.2rem" }}>📊</span>
                          Financials
                        </div>
                        <div
                          style={{
                            color: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.75rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          Reports and statements
                        </div>
                      </div>

                      <div style={{ padding: "0.5rem" }}>
                        <Link
                          to="/TBalance"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(59, 130, 246, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickTB("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            ⚖️
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#1e40af",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Trial Balance
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              View account balances
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#3b82f6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/Ledger"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #bfdbfe 0%, #93c5fd 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(37, 99, 235, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickLedger("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            📚
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#1e40af",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Ledger
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              General ledger accounts
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#3b82f6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/soCI"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(29, 78, 216, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickSoCI("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            📊
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#1e40af",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Income Statement
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Statement of Comp. Income
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#3b82f6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/soFP"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(59, 130, 246, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickSoFP("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            💰
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#1e40af",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Balance Sheet
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Statement of Fin. Position
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#3b82f6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/soCE"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #bfdbfe 0%, #93c5fd 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(37, 99, 235, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickSoCE("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            📈
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#1e40af",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Equity Statement
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Statement of Changes in Equity
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#3b82f6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/cashflow"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(29, 78, 216, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickCashflow("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            💸
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#1e40af",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Cashflow
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Cash flow analysis
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#3b82f6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/PdfDisplay"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(59, 130, 246, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() =>
                            setStylingOnClickPdfDisplay("MediumBlue")
                          }
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            📄
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#1e40af",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Annual Fin. Statements
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Generate AFS reports
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#3b82f6",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* Tasks Link */}
              <Link className="nav-link active" to={"/TasksPage"}>
                <li
                  className="nav-item compact-nav-item"
                  style={{
                    color: stylingOnClickTasks,
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    fontWeight: stylingOnClickTasks ? "600" : "normal",
                  }}
                  onMouseOver={(e) => {
                    if (!stylingOnClickTasks) {
                      e.target.style.backgroundColor = "rgba(255,255,255,0.2)";
                      e.target.style.transform = "translateY(-1px)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!stylingOnClickTasks) {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.transform = "translateY(0px)";
                    }
                  }}
                  onClick={() => setStylingOnClickTasks("MediumBlue")}
                  title="Work, timesheets and billing"
                >
                  Work &amp; Billing
                </li>
              </Link>
              <span
                style={{
                  margin: "0 8px",
                  color: "#6b7280",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                |
              </span>
              {/* Tax & Budget Dropdown */}
              <li
                className="nav-item"
                style={{
                  position: "relative",
                  zIndex: showTaxBudgetDropdown ? 10000 : "auto",
                }}
                onMouseEnter={
                  !isTouchDevice
                    ? () => setShowTaxBudgetDropdown(true)
                    : undefined
                }
                onMouseLeave={
                  !isTouchDevice
                    ? () => setShowTaxBudgetDropdown(false)
                    : undefined
                }
              >
                <div
                  className="nav-link compact-nav-item"
                  style={{
                    color: showTaxBudgetDropdown
                      ? "#ffffff"
                      : stylingOnClickTax || stylingOnClickBudget
                      ? "MediumBlue"
                      : "#4b5563",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight:
                      stylingOnClickTax || stylingOnClickBudget
                        ? "600"
                        : "normal",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    padding: "6px 8px",
                    background: showTaxBudgetDropdown
                      ? "linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%)"
                      : "transparent",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowTaxBudgetDropdown(!showTaxBudgetDropdown);
                  }}
                >
                  💰 Tax & Budget
                  <span
                    className={`fancy-plus ${
                      showTaxBudgetDropdown ? "open" : ""
                    }`}
                    style={{
                      color: showTaxBudgetDropdown ? "#fff" : "inherit",
                    }}
                  />
                </div>
                {showTaxBudgetDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      minWidth: "320px",
                      paddingTop: "0.5rem",
                      zIndex: 10000,
                      opacity: showTaxBudgetDropdown ? 1 : 0,
                      visibility: showTaxBudgetDropdown ? "visible" : "hidden",
                      transform: showTaxBudgetDropdown
                        ? "translateY(0) scale(1)"
                        : "translateY(-10px) scale(0.95)",
                      transition:
                        "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                      pointerEvents: showTaxBudgetDropdown ? "auto" : "none",
                    }}
                  >
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #fef3c7 100%)",
                        borderRadius: "12px",
                        boxShadow: showTaxBudgetDropdown
                          ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                          : "none",
                        border: "1px solid #fbbf24",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          padding: "1rem 1.25rem",
                          borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontWeight: "700",
                            fontSize: "0.95rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <span style={{ fontSize: "1.2rem" }}>💰</span>
                          Tax & Budget
                        </div>
                        <div
                          style={{
                            color: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.75rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          Manage taxes and budgets
                        </div>
                      </div>

                      <div style={{ padding: "0.5rem" }}>
                        <Link
                          to="/PayrollDashboard"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #fecaca 0%, #fca5a5 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(239, 68, 68, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(239, 68, 68, 0.3)",
                            }}
                          >
                            👥
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#991b1b",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Payroll
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Manage payroll and payslips
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#ef4444",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/VatCalculation"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(245, 158, 11, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(245, 158, 11, 0.3)",
                            }}
                          >
                            📊
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#92400e",
                                marginBottom: "0.15rem",
                              }}
                            >
                              VAT
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              VAT calculations & returns
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#f59e0b",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/ProvTax"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #fed7aa 0%, #fdba74 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(217, 119, 6, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickTax("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(245, 158, 11, 0.3)",
                            }}
                          >
                            ⚙️
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#92400e",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Tax Settings
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Configure tax settings
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#f59e0b",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/ProvTaxCalc"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #fed7aa 0%, #fdba74 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(217, 119, 6, 0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickTax("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(245, 158, 11, 0.3)",
                            }}
                          >
                            🧾
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#92400e",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Provisional Tax
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Tax calculations & provisioning
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#f59e0b",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>

                        <Link
                          to="/Budget"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.875rem 1rem",
                            borderRadius: "8px",
                            textDecoration: "none",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            backgroundColor: "transparent",
                            marginTop: "0.25rem",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)";
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 6px -1px rgba(16, 185, 129, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => setStylingOnClickBudget("MediumBlue")}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "1.25rem",
                              boxShadow:
                                "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            💰
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.9rem",
                                color: "#065f46",
                                marginBottom: "0.15rem",
                              }}
                            >
                              Budget
                            </div>
                            <div
                              style={{
                                fontSize: "0.75rem",
                                color: "#78716c",
                                lineHeight: "1.2",
                              }}
                            >
                              Manage budgets & spending
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#10b981",
                              fontSize: "1.25rem",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            →
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* Admin Chat - Only for admin users */}
              {emailDetails?.includes("filingstack@gmail.com") && (
                <>
                  <span
                    style={{
                      margin: "0 8px",
                      color: "#6b7280",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    |
                  </span>
                  <Link className="nav-link active" to="/AdminChat">
                    <li
                      className="nav-item compact-nav-item"
                      style={{
                        color: "orange",
                        borderRadius: "6px",
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                        fontWeight: "600",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "rgba(255,165,0,0.2)";
                        e.target.style.transform = "translateY(-1px)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.transform = "translateY(0px)";
                      }}
                      title="Admin Chat Dashboard"
                    >
                      💬 Admin Chat
                    </li>
                  </Link>
                  <Link className="nav-link active" to="/AdminUpdates">
                    <li
                      className="nav-item compact-nav-item"
                      style={{
                        color: "#2563eb",
                        borderRadius: "6px",
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                        fontWeight: 600,
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor =
                          "rgba(37, 99, 235, 0.15)";
                        e.target.style.transform = "translateY(-1px)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.transform = "translateY(0px)";
                      }}
                      title="Publish product updates and announcements"
                    >
                      📝 Admin Updates
                    </li>
                  </Link>
                </>
              )}
            </ul>
            <div className="nav-right-panel">
              <div className="nav-actions-row">
                <Link
                  target="_blank"
                  rel="noreferrer"
                  to="./UsageInfo"
                  title="Documentation & Tips"
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      background: "rgba(59, 130, 246, 0.14)",
                      color: "#2563eb",
                      boxShadow: "0 1px 2px rgba(59, 130, 246, 0.18)",
                      transition: "all 0.2s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow =
                        "0 3px 8px rgba(59, 130, 246, 0.28)";
                      e.currentTarget.style.background =
                        "rgba(59, 130, 246, 0.2)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0px)";
                      e.currentTarget.style.boxShadow =
                        "0 1px 2px rgba(59, 130, 246, 0.18)";
                      e.currentTarget.style.background =
                        "rgba(59, 130, 246, 0.14)";
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-book"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
                    </svg>
                  </span>
                </Link>
                <Link
                  to="./UserProfile"
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 10,
                    background:
                      "linear-gradient(135deg, #0f172a 0%, #1e3a8a 35%, #1d4ed8 70%, #0ea5e9 100%)",
                    color: "#fff",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none",
                    boxShadow: "0 2px 8px rgba(17, 24, 39, 0.25)",
                    transition: "all 0.2s ease",
                    fontWeight: 800,
                    letterSpacing: "0.02em",
                    fontSize: 20,
                  }}
                  className="badge badge-pill badge-info"
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 14px rgba(17, 24, 39, 0.35)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(17, 24, 39, 0.25)";
                  }}
                  title={emailDetails}
                >
                  {emailDetails?.slice(0, 1)}
                </Link>
                {/* <Link
                  to="./AuditLogs"
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 10,
                    background:
                      "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)",
                    color: "#fff",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none",
                    boxShadow: "0 2px 8px rgba(99, 102, 241, 0.25)",
                    transition: "all 0.2s ease",
                    fontSize: 16,
                  }}
                  className="badge badge-pill"
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 14px rgba(99, 102, 241, 0.35)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(99, 102, 241, 0.25)";
                  }}
                  title="Audit Logs"
                >
                  📋
                </Link> */}
                {savedIcon === "Saving..." ? (
                  <label
                    htmlFor="saved"
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      letterSpacing: "0.02em",
                      color: "#4b5563",
                    }}
                  >
                    {savedIcon}
                  </label>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                    style={{ color: "#10b981" }}
                    title="Saved"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-.708-.708L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                )}
              </div>
              <div className={statusChipClassName} title={statusTitle}>
                <span
                  className="status-dot"
                  style={{ backgroundColor: dotColor, boxShadow: dotShadow }}
                />
                <span>{isOnline ? "Online" : "Offline"}</span>
                {isOnline && qualityLabel && (
                  <span className="status-quality">{qualityLabel}</span>
                )}
              </div>
            </div>
            <div className="space" />
            {/* <div>
              {savedIcon === "Saving..." ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="sr-only"></span>
                </div>
              ) : (
                <svg
                  id="saved"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-check2-all"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7l-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z" />
                  <path d="M5.354 7.146l.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z" />
                </svg>
              )}
            </div> */}
            <span
            //className="d-flex"
            >
              <Logout />
              <Route exact path="/Login" component={Login} />
            </span>
            {/* <Link to="/Login">Logout</Link> */}
          </div>{" "}
          {/* </div> */}
        </nav>
      </div>
    </FirebaseAuth>
  );
}

export default Navigation;
